var P = Object.defineProperty, R = Object.defineProperties;
var W = Object.getOwnPropertyDescriptors;
var e = Object.getOwnPropertySymbols;
var y = Object.prototype.hasOwnProperty, v = Object.prototype.propertyIsEnumerable;
var h = (r, o, s) => o in r ? P(r, o, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[o] = s, p = (r, o) => {
  for (var s in o || (o = {}))
    y.call(o, s) && h(r, s, o[s]);
  if (e)
    for (var s of e(o))
      v.call(o, s) && h(r, s, o[s]);
  return r;
}, u = (r, o) => R(r, W(o));
var w = (r, o) => {
  var s = {};
  for (var t in r)
    y.call(r, t) && o.indexOf(t) < 0 && (s[t] = r[t]);
  if (r != null && e)
    for (var t of e(r))
      o.indexOf(t) < 0 && v.call(r, t) && (s[t] = r[t]);
  return s;
};
import { jsx as A } from "react/jsx-runtime";
import { Children as F } from "react";
import { b as G } from "./get-size-Bc1Pz5yf.js";
import { c as V } from "./create-vars-resolver-Bzbn9G-G.js";
import { f as k, u as q, B as D } from "./factory-ueRxoNOV.js";
import { u as E } from "./use-styles-DToiHEa6.js";
function H(r) {
  return F.toArray(r).filter(Boolean);
}
var x = { root: "m_4081bf90" };
const I = {
  preventGrowOverflow: !0,
  gap: "md",
  align: "center",
  justify: "flex-start",
  wrap: "wrap"
}, J = V(
  (r, { grow: o, preventGrowOverflow: s, gap: t, align: a, justify: l, wrap: n }, { childWidth: i }) => ({
    root: {
      "--group-child-width": o && s ? i : void 0,
      "--group-gap": G(t),
      "--group-align": a,
      "--group-justify": l,
      "--group-wrap": n
    }
  })
), C = k((r, o) => {
  const s = q("Group", I, r), g = s, {
    classNames: t,
    className: a,
    style: l,
    styles: n,
    unstyled: i,
    children: j,
    gap: c,
    align: K,
    justify: L,
    wrap: M,
    grow: _,
    preventGrowOverflow: Q,
    vars: $,
    variant: B,
    __size: N,
    mod: S
  } = g, b = w(g, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "children",
    "gap",
    "align",
    "justify",
    "wrap",
    "grow",
    "preventGrowOverflow",
    "vars",
    "variant",
    "__size",
    "mod"
  ]), d = H(j), m = d.length, f = G(c != null ? c : "md"), z = { childWidth: `calc(${100 / m}% - (${f} - ${f} / ${m}))` }, O = E({
    name: "Group",
    props: s,
    stylesCtx: z,
    className: a,
    style: l,
    classes: x,
    classNames: t,
    styles: n,
    unstyled: i,
    vars: $,
    varsResolver: J
  });
  return /* @__PURE__ */ A(
    D,
    u(p(u(p({}, O("root")), {
      ref: o,
      variant: B,
      mod: [{ grow: _ }, S],
      size: N
    }), b), {
      children: d
    })
  );
});
C.classes = x;
C.displayName = "@mantine/core/Group";
export {
  C as G
};
